import { styled } from "@mui/material";
import Button from "../../../../customs/Button";

const DisableRoleContent = () => {
    return (
        <StyledContainer>
            <StyledText>You are about to disable <strong>Finance Officer Role</strong></StyledText>
            <ButtonWrapper>
                <ButtonContainer>
                    <StyledButton text='Cancel'/>
                    <StyledButton type="submit" text='Disable'/>
                </ButtonContainer>
            </ButtonWrapper>
        </StyledContainer>
    )
}

export default DisableRoleContent;

const StyledContainer = styled('div')`
    margin-inline-start: 3.5rem;
    margin-block: 2.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
    padding-inline: 3.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
    background-color: #DD5151;
`

const StyledText = styled('span')`
    color: #232323;
    font-size: 1.4rem;
    font-weight: 400;
`